import { useContext, useEffect } from "react";
import { NavigationContext } from "../contexts/NavigationContext";

const useMenuTitle = (menuTitle) => {
  const { updatePageTitle } = useContext(NavigationContext);

  useEffect(() => {
    updatePageTitle(menuTitle);

    // Reset the page title when the component unmounts
    //return () => updatePageTitle("Menu");
  }, [menuTitle, updatePageTitle]);
};

export default useMenuTitle;
